import tmsApi from './../api/tmsApi';

export default {
  namespaced: true,
  state: {
    selectedReport: '',
    reports: [],
    tableFields: [],
    tableItems: [],
    query: {
      page: {
        number: 1,
        count: 20,
      },
      sort: [],
      filter: {},
      format: 'XLSX',
    },
    result: {
      page: {
        number: 1,
        count: 20,
      },
      total: 0,
      tabs: [],
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.reports.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.reports.push(data);
    },
    SELECT_REPORT(state, reportName) {
      state.selectedReport = reportName;
    },
    CLEAR_TABLE_ITEM(state) {
      state.tableItems.splice(0);
    },
    ADD_ITEM_ON_LIST(state, data) {
      state.tableItems.push(data);
    },
    CLEAR_TABLE_FIELD(state) {
      state.tableFields.splice(0);
    },
    CLEAR_QUERY_SORT_FILTER(state) {
      state.query.sort.splice(0);
      state.query.filter = {};
    },
    CLEAR_QUERY_FILTER(state) {
      state.query.filter = {};
    },
    CLEAR_RESULT_TOTAL(state) {
      state.result.total = 0;
    },
    ADD_FIELD_ON_LIST(state, data) {
      if (data.key === 'no') {
        data.sortable = false;
        data.filterable = false;
      }

      state.tableFields.push(data);
    },
    SET_QUERY_SORT(state, sort) {
      state.query.sort = sort;
    },
    SET_QUERY_FILTER(state, filter) {
      state.query.filter = filter;
    },
    SET_QUERY_PAGE_NUMBER(state, value) {
      state.query.page.number = value;
    },
    SET_QUERY_PAGE_COUNT(state, value) {
      state.query.page.count = value;
    },
    SET_RESULT_PAGE_NUMBER(state, value) {
      state.result.page.number = value;
    },
    SET_RESULT_PAGE_COUNT(state, value) {
      state.result.page.count = value;
    },
    SET_RESULT_TOTAL(state, value) {
      state.result.total = value;
    },
    SET_RESULT_TAB(state, value) {
      state.result.tabs = value;
    },
    SET_REPORT_FORMAT(state, value) {
      state.query.format = value;
    },
    ADD_ERROR(state, error) {
      state.errors.actions.push(error);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
  },
  getters: {
    reports(state) {
      return state.reports;
    },
    selectedReport(state) {
      return state.selectedReport;
    },
    tableFields(state) {
      return state.tableFields;
    },
    tableItems(state) {
      return state.tableItems;
    },
    resultPageNumber(state) {
      return state.result.page.number;
    },
    resultPageCount(state) {
      return state.result.page.count;
    },
    resultTotal(state) {
      return state.result.total;
    },
    tableFieldsSort(state) {
      return state.query.sort;
    },
    tableFilter(state) {
      return state.query.filter;
    },
    resultTabs(state) {
      return state.result.tabs;
    },
  },
  actions: {
    LOAD_DATA({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          reports {
            name
            title
            iconClass
            namespace
            fields {
              key
              label
              sortable
              filterable
            }
            options {
              key
              type
              required
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'reports').then(({ data }) => {
        const { reports } = data;
        reports.forEach((user) => {
          commit('ADD_DATA_ON_LIST', user);
        }, this);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA');
      });
    },
    LOAD_REPORT_DATA({ commit, rootState, state }, options) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
          query ReportData($report_name: String!, $options: JSON, $view: ReportView){
            result: get_report_data(report_name: $report_name, options: $options, view: $view) {
            total
            options
            fields
            data
            view
            tabs {
              value
              text
            }
          }
        }
      `;

      const variables = {
        options,
        report_name: state.selectedReport,
        view: {
          page: state.query.page,
          sort: state.query.sort,
          filter: state.query.filter,
        },
      };

      return api({
        query,
        variables,
      }, 'generate_report').then(({ data }) => {
        const {
          data: results, total, fields, view, tabs,
        } = data.result;
        commit('SET_RESULT_TOTAL', total);
        commit('SET_RESULT_PAGE_NUMBER', view.page.number);
        commit('SET_RESULT_PAGE_COUNT', view.page.count);
        commit('SET_RESULT_TAB', tabs);
        commit('CLEAR_TABLE_ITEM');
        commit('CLEAR_TABLE_FIELD');
        results.forEach((result) => {
          commit('ADD_ITEM_ON_LIST', result);
        });
        fields.forEach((field) => {
          commit('ADD_FIELD_ON_LIST', field);
        });
        return true;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_REPORT_DATA');
      });
    },
    EXPORT_REPORT_DATA({ rootState, state, commit }, options) {
      const api = tmsApi.build(rootState.token);
      const query = `
          query ExportReport($report_name: String!, $options: JSON, $view: ReportView, $format: ReportFileFormat){
            result: export_report_data(report_name: $report_name, options: $options, view: $view, format: $format) {
            job_id
          }
        }
      `;

      const variables = {
        options,
        report_name: state.selectedReport,
        format: state.query.format,
        view: {
          page: state.query.page,
          sort: state.query.sort,
          filter: state.query.filter,
        },
      };

      return api({
        query,
        variables,
      }, 'export_report')
        .then(({ data }) => data)
        .catch(() => {
          commit('ADD_ERROR', 'EXPORT_REPORT_DATA');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/reports.js